import { useState, useEffect, useCallback } from "react";
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import api from "@/lib/api";

export default function Layout() {
  const [conversas, setConversas] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const reloadConversas = useCallback(async () => {
    try {
      const { data } = await api.get("/conversas");
      setConversas(data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    reloadConversas();
  }, [reloadConversas]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-[#080c14] text-slate-100">
      {/* Mobile toggle */}
      <button
        data-testid="mobile-sidebar-toggle"
        onClick={() => setMobileOpen((v) => !v)}
        className="lg:hidden fixed top-3 left-3 z-50 p-2 rounded-lg bg-slate-900/90 border border-slate-700/60 backdrop-blur"
      >
        {mobileOpen ? <X size={18} /> : <Menu size={18} />}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed lg:relative z-40 h-full transition-transform duration-300 ${
          mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <Sidebar
          conversas={conversas}
          activeId={params.conversaId}
          reloadConversas={reloadConversas}
        />
      </div>
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-30 bg-black/60" onClick={() => setMobileOpen(false)} />
      )}

      {/* Content */}
      <main className="flex-1 h-full overflow-hidden relative">
        <Outlet context={{ reloadConversas, conversas }} />
      </main>
    </div>
  );
}
